/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbMobileRefineMenuFilterDeliveryOptions_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterDeliveryOptions_itemSearch">;
    readonly " $refType": "SbMobileRefineMenuFilterDeliveryOptions_itemSearch";
};
export type SbMobileRefineMenuFilterDeliveryOptions_itemSearch$data = SbMobileRefineMenuFilterDeliveryOptions_itemSearch;
export type SbMobileRefineMenuFilterDeliveryOptions_itemSearch$key = {
    readonly " $data"?: SbMobileRefineMenuFilterDeliveryOptions_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbMobileRefineMenuFilterDeliveryOptions_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbMobileRefineMenuFilterDeliveryOptions_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterDeliveryOptions_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '8c3bf49b45474c38e357c12d08ff45d9';
export default node;
